// PL · Recorrido de novedades (TourNovedades.vue)
export const tourNovedades = {
  "title": "Nowości w WA Checkin",
  "kicker": "Nowości",
  "stepOf": "Krok {n} z {total}",
  "close": "Zamknij",
  "dontShow": "Nie pokazuj ponownie",
  "prev": "Wstecz",
  "next": "Dalej",
  "done": "Rozumiem",
  "steps": {
    "icons": {
      "title": "Ikony przy rezerwacjach",
      "text": "Każda rezerwacja w kalendarzu i na liście pokazuje teraz małe ikony: prośby do Recepcji AI, połączenia, notatki oraz czy zostało coś do zapłaty. Najedź na nie kursorem, aby zobaczyć szczegóły bez otwierania rezerwacji.",
      "cta": ""
    },
    "early": {
      "title": "Płatne wcześniejsze zameldowanie",
      "text": "Wcześniejsze zameldowanie może mieć teraz cenę. Agent AI pyta o godzinę przyjazdu, oblicza koszt i wysyła link do płatności. Po opłaceniu potwierdza się automatycznie.",
      "cta": "Skonfiguruj w Agencie AI"
    },
    "reception": {
      "title": "Recepcja AI",
      "text": "Wszystko, o co goście proszą agenta (wcześniejsze wejście, późniejsze wyjście, dodatkowe noce, faktury, wiadomości z połączeń), trafia do jednej skrzynki. Zatwierdzasz, odrzucasz lub nadajesz priorytet jednym kliknięciem i widzisz kwotę tego, co jest pobierane.",
      "cta": "Otwórz Recepcję AI"
    },
    "translate": {
      "title": "Tłumaczenie na żywo",
      "text": "W czacie każdej rezerwacji i w skrzynce odbiorczej włącz tłumaczenie: to, co pisze gość, dociera do ciebie w twoim języku, a po naciśnięciu Enter najpierw widzisz swoją wiadomość przetłumaczoną na jego język, zanim ją wyślesz.",
      "cta": "Przejdź do wiadomości"
    },
    "voice": {
      "title": "Połączenia z agentem głosowym",
      "text": "Włącz recepcję telefoniczną: agent AI odbiera połączenia w języku dzwoniącego, odpowiada na pytania, wysyła link do rezerwacji i zostawia ci podsumowanie każdej rozmowy.",
      "cta": "Włącz połączenia"
    }
  },
  "demo": {
    "iconsTipTitle": "Recepcja AI",
    "iconsTipEarly": "Wcześniejsze zameldowanie",
    "iconsTipPending": "Do zapłaty:",
    "paid": "Opłacona",
    "earlyGuest": "Czy możemy wejść o 11:00?",
    "earlyAgent": "Tak! Wejście o 11:00 kosztuje 30 €. Możesz zapłacić tutaj:",
    "earlyPaid": "Opłacona · potwierdzona",
    "rx": {
      "early": "Wcześniejsze wejście",
      "late": "Późne wyjście",
      "extend": "Przedłużenie"
    },
    "pending": "Oczekuje",
    "confirmed": "Potwierdzona",
    "trGuestOrig": "What time can we pick up the keys?",
    "trGuestMine": "O której możemy odebrać klucze?",
    "trMine": "Od 15:00, czekamy na was",
    "trTheirs": "From 3 pm, we look forward to seeing you",
    "voiceSummaryTitle": "Podsumowanie rozmowy",
    "voiceSummary": "Zapytał o parking i zarezerwował 2 noce. Link do rezerwacji wysłany przez WhatsApp."
  }
};
